module.exports = __webpack_public_path__ + "img/ic_dashboard.313f98fb.svg";